G.PreloaderBar = function(){
	
	Phaser.Group.call(this,game);
	this.fixedToCamera = true;

	this.softgamesBtn = game.add.button(0,200,'sg_logo',function(){
		SG_Hooks.triggerMoreGames();
	},this);
	this.softgamesBtn.anchor.setTo(0.5,0.5);
	this.add(this.softgamesBtn);

	this.gfx = game.add.graphics();
	this.add(this.gfx);
	this.drawProgress(0);

	G.sb('onScreenResize').add(this.onResize,this);
	this.onResize();

	game.load.onFileComplete.add(this.drawProgress,this);

};

G.PreloaderBar.prototype = Object.create(Phaser.Group.prototype);

G.PreloaderBar.prototype.onResize = function(){

	this.cameraOffset.x = game.width*0.5;
	this.cameraOffset.y = game.height*0.4;

};

G.PreloaderBar.prototype.drawProgress = function(progress){

	this.gfx.clear();
	this.gfx.lineStyle(2,0xffffff,1);
	this.gfx.beginFill(0x000000,1);
	this.gfx.drawRect(-150,0,300,50);
	this.gfx.beginFill(0xffffff,1);
	this.gfx.drawRect(-145,5,(progress/100)*290,40);

};